import React from "react";

import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";

import { IMenuTabs } from "./interface";
import { colors } from "../../global/globalStyle";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      className="simple-tabpanel-zero"
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0, fontFamily: "Inter", height: "none" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const MenuTabsKenta: React.FC<IMenuTabs> = ({
  pageDefault,
  setPage,
  menuList,
  bodyList,
}) => {
  const [value, setValue] = React.useState(pageDefault || 0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    if (setPage) {
      setPage(newValue);
    }
  };

  return (
    <Box
      id="container_tabs_zero"
      sx={{ width: "100%", height: "none", p: 0, m: 0 }}
    >
      <Box
        id="container_tabs_one"
        sx={{ borderBottom: 1, borderColor: "divider", p: 0, m: 0 }}
      >
        <Tabs
          id="container_tabs_zero"
          textColor="inherit"
          TabIndicatorProps={{
            style: { backgroundColor: colors.default_base_orange },
          }}
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          {menuList.map((item) => (
            <Tab
              key={item.id}
              sx={{ textTransform: "capitalize" }}
              label={item.value}
              {...a11yProps(item.id)}
              id="container_tabs_one"
            />
          ))}
        </Tabs>
      </Box>
      {bodyList.map((Item) => (
        <CustomTabPanel key={Item.id} value={value} index={Item.id}>
          {Item.Component}
        </CustomTabPanel>
      ))}
    </Box>
  );
};

export default MenuTabsKenta;
